import type { Region } from 'react-native-maps';

export const getMapCorners = (region: Region): string[] => {
  const { latitude, longitude, latitudeDelta, longitudeDelta } = region;

  const topLeft = `"${latitude + latitudeDelta / 2}, ${longitude - longitudeDelta / 2}"`;
  const topRight = `"${latitude + latitudeDelta / 2}, ${longitude + longitudeDelta / 2}"`;
  const bottomLeft = `"${latitude - latitudeDelta / 2}, ${longitude - longitudeDelta / 2}"`;
  const bottomRight = `"${latitude - latitudeDelta / 2}, ${longitude + longitudeDelta / 2}"`;

  return [topLeft, topRight, bottomRight, bottomLeft];
};
